import { r as registerInstance, h, H as Host, c as prefix, g as getElement } from './breakpointCustomizable-ff31979d.js';
import { i as insertSlottedStyles } from './slotted-styles-9a18361d.js';
var textListItemCss = ":host{position:relative !important;display:list-item !important;color:inherit !important;list-style-type:none !important}:host(.p-text-list-item--unordered){padding-left:1.5rem !important}:host(.p-text-list-item--unordered)::before{content:\"\" !important;position:absolute !important;left:0 !important;top:calc(1.5em / 2 - 0.125em) !important;width:0.25rem !important;height:0.25rem !important;background-color:currentColor !important}:host(.p-text-list-item--unordered.p-text-list-item--nested)::before{height:1px !important;width:0.5rem !important;top:calc(1.5em / 2) !important}:host(.p-text-list-item--ordered){padding-left:2.5rem !important}:host(.p-text-list-item--ordered)::before{position:absolute !important;right:calc(100% - 24px) !important;top:0 !important;counter-increment:section !important;text-align:right !important;font-size:1rem;line-height:1.5;font-family:\"Porsche Next\", \"Arial Narrow\", Arial, sans-serif;font-weight:400}:host(.p-text-list-item--ordered-numbered)::before{content:counters(section, \".\", decimal) \".\" !important}:host(.p-text-list-item--ordered-alphabetically)::before{content:counters(section, \".\", lower-latin) \".\" !important}:host(.p-text-list-item--ordered-numbered.p-text-list-item--nested)::before{content:counters(section, \".\", decimal) !important}:host(.p-text-list-item--ordered-alphabetically.p-text-list-item--nested)::before{content:counters(section, \".\", lower-latin) !important}";
var TextListItem = /** @class */ (function () {
    function TextListItem(hostRef) {
        registerInstance(this, hostRef);
    }
    TextListItem.prototype.componentDidLoad = function () {
        this.addSlottedStyles();
    };
    TextListItem.prototype.render = function () {
        var _a;
        var textListItemClasses = (_a = {},
            _a[prefix('text-list-item')] = true,
            _a[prefix("text-list-item--" + this.typeOfList)] = true,
            _a[prefix("text-list-item--ordered-" + this.typeOfOrderedList)] = this.typeOfList === 'ordered',
            _a[prefix('text-list-item--nested')] = this.isNestedList,
            _a);
        return (h(Host, { role: "listitem", class: textListItemClasses }, h("slot", null)));
    };
    Object.defineProperty(TextListItem.prototype, "typeOfList", {
        get: function () {
            var list = this.host.closest(prefix('text-list'));
            return list.getAttribute('list-type');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextListItem.prototype, "typeOfOrderedList", {
        get: function () {
            var list = this.host.closest(prefix('text-list'));
            return list.getAttribute('order-type');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextListItem.prototype, "isNestedList", {
        get: function () {
            return !!this.host.closest(prefix('text-list[nested]'));
        },
        enumerable: false,
        configurable: true
    });
    TextListItem.prototype.addSlottedStyles = function () {
        var tagName = this.host.tagName.toLowerCase();
        var style = tagName + " a {\n      outline: none transparent;\n      color: inherit;\n      text-decoration: underline;\n      -webkit-transition: outline-color .24s ease, color .24s ease;\n      transition: outline-color .24s ease, color .24s ease;\n    }\n\n    " + tagName + " a:hover {\n      color: #d5001c;\n    }\n\n    " + tagName + " a:focus {\n      outline: 2px solid #00d5b9;\n      outline-offset: 1px;\n    }\n    ";
        insertSlottedStyles(this.host, style);
    };
    Object.defineProperty(TextListItem.prototype, "host", {
        get: function () { return getElement(this); },
        enumerable: false,
        configurable: true
    });
    return TextListItem;
}());
TextListItem.style = textListItemCss;
export { TextListItem as p_text_list_item };
